import { get } from 'lodash';

export { DocumentBuilderPageComponent } from './lib/document-builder/document-builder-page.component';
export { DocumentBuilderPageDirective } from './lib/document-builder/document-builder-page.base.directive';

export { DocumentBuilderDocumentDirective } from './lib/document-builder/document-builder-sections';

export { DynamicFormsPresentationAdapter } from './lib/adapters/dynamic-forms-adapter.service';
export { SimpleTableComponent } from './lib/components/simple-table.component';

export * from './lib/presentation-builder.module';
export * from './lib/document-builder';
export * from './lib/adapters';
export * from './lib/value-accessors';

export {
  TINYMCE_EDITOR_OPTIONS,
  TinymceEditorOptions,
  providePresentationBuilder,
} from './lib/providers';

export { DocumentData, DocumentBuilderData } from './lib/interfaces';

export {
  DOCUMENT_TEMPLATES,
  getPartnerTemplates,
  getTemplate,
} from './lib/templates/templates';

export * from './lib/templates/pnc';

export const filePickerCallback = (cb: any, value: any, meta: any) => {
  const input = document.createElement('input');
  input.setAttribute('type', 'file');
  input.setAttribute('accept', 'image/*');

  input.addEventListener('change', (e) => {
    const files = get(e, 'target.files') as unknown as FileList;
    if (!files) {
      return;
    }
    const file = files[0];

    const reader = new FileReader();
    reader.addEventListener('load', () => {
      const id = 'blobid' + new Date().getTime();
      const tinymce = get(window, 'tinymce') as any;
      if (!tinymce || !tinymce.activeEditor) {
        return;
      }
      const blobCache = tinymce.activeEditor.editorUpload.blobCache;
      const base64 = (reader.result as string).split(',')[1];
      const blobInfo = blobCache.create(id, file, base64);
      blobCache.add(blobInfo);

      /* call the callback and populate the Title field with the file name */
      cb(blobInfo.blobUri(), { title: file.name });
    });
    reader.readAsDataURL(file);
  });

  input.click();
};
